import { TSubCategoryProps } from 'Pages/Home/Components/Atoms/Card/Card';
import DailyBeaters from 'images/SubCategories/DailyBeaters.png';
import HotProducts from 'images/SubCategories/HotProducts.png';
import InstantShipping from 'images/SubCategories/InstantShipping.png';
import Kids from 'images/SubCategories/Kids.png';
import LifeInLuxury from 'images/SubCategories/LifeInLuxury.png';
import Men from 'images/SubCategories/Men.png';
import UnderRetail from 'images/SubCategories/UnderRetail.png';
import Women from 'images/SubCategories/Women.png';

type TSubCategoryData = TSubCategoryProps & {
  s3ImageName: string;
  redirectUrl: string;
};

export const SUB_CATEGORY_DATA: TSubCategoryData[] = [
  {
    title: 'Hot Products',
    backgroundColor: '#fa897b',
    backgroundImage: HotProducts,
    s3ImageName: 'hot_products.png',
    redirectUrl: 'hot-products',
  },
  {
    title: 'Men',
    backgroundColor: '#d0e6a5',
    backgroundImage: Men,
    s3ImageName: 'men.png',
    redirectUrl: 'browse-all?sex=M',
  },
  {
    title: 'Women',
    backgroundColor: '#eccff6',
    backgroundImage: Women,
    s3ImageName: 'women.png',
    redirectUrl: 'browse-all?sex=F',
  },
  {
    title: 'Kids/Toddler',
    backgroundColor: '#ffda8c',
    backgroundImage: Kids,
    s3ImageName: 'kids.png',
    redirectUrl: 'browse-all?sex=Y',
  },
  {
    title: 'Under Retail',
    backgroundColor: '#ffda8c',
    backgroundImage: UnderRetail,
    s3ImageName: 'under_retail.png',
    redirectUrl: 'collection/under-retail',
  },
  {
    title: 'Life in Luxury',
    backgroundColor: '#fa897b',
    backgroundImage: LifeInLuxury,
    s3ImageName: 'life_in_luxury.png',
    redirectUrl: 'luxury/hot-products',
  },
  {
    title: 'Instant Shipping',
    backgroundColor: '#b0efe1',
    backgroundImage: InstantShipping,
    s3ImageName: 'instant_shipping.png',
    redirectUrl: 'browse-all?sneakers_condition=pre_verified',
  },
  {
    title: 'Daily Beaters',
    backgroundColor: '#d0e6a5',
    backgroundImage: DailyBeaters,
    s3ImageName: 'daily_beaters.png',
    redirectUrl: 'collection/daily-beaters',
  },
];

export const EVENT_CATEGORY_DATA: TSubCategoryData[] = [
  {
    title: 'Sale',
    backgroundColor: '#fa897b',
    backgroundImage: UnderRetail,
    s3ImageName: '1.png',
    redirectUrl: 'collection/1111-sale',
  },
  {
    title: 'Men',
    backgroundColor: '#d0e6a5',
    backgroundImage: Men,
    s3ImageName: '1.png',
    redirectUrl: 'browse-all?sex=M',
  },
  {
    title: 'Women',
    backgroundColor: '#eccff6',
    backgroundImage: Women,
    s3ImageName: '1.png',
    redirectUrl: 'browse-all?sex=F',
  },
  {
    title: 'Kids/Toddler',
    backgroundColor: '#ffda8c',
    backgroundImage: Kids,
    s3ImageName: '1.png',
    redirectUrl: 'browse-all?sex=Y',
  },
  {
    title: 'Hot Products',
    backgroundColor: '#ffda8c',
    backgroundImage: HotProducts,
    s3ImageName: '2.png',
    redirectUrl: 'hot-products',
  },

  {
    title: 'Life in Luxury',
    backgroundColor: '#fa897b',
    backgroundImage: LifeInLuxury,
    s3ImageName: '0.png',
    redirectUrl: 'luxury/hot-products',
  },
  {
    title: 'Instant Shipping',
    backgroundColor: '#b0efe1',
    backgroundImage: InstantShipping,
    s3ImageName: '2.png',
    redirectUrl: 'browse-all?sneakers_condition=pre_verified',
  },
  {
    title: 'Merchandise',
    backgroundColor: '#d0e6a5',
    backgroundImage: DailyBeaters,
    s3ImageName: '2.png',
    redirectUrl: 'collection/merchandise',
  },
];
